import type { ApiClientOptions } from '@/infra/api-client'
import { patchGrpcClient } from '@/utils/grpc-util'
import { InventoryItemServicePromiseClient } from '@taxfyle/api-internal/internal/inventory_item_grpc_web_pb'

export class InventoryApi {
  readonly inventoryItems

  constructor(options: ApiClientOptions) {
    this.inventoryItems = new InventoryItemServicePromiseClient(
      options.baseURL ?? '',
    )
    patchGrpcClient(this.inventoryItems, options.token$)
  }
}
